<template>
<div :class="'pcqb-tabs '+(cls||'')">
  <slot></slot>
</div>
</template>
<script>
export default {
  data() {
    return {
      activeName: this.value
    };
  },
  props: {
    value: String,
    hover: Boolean,
    cls: String
  },
  methods: {
  },
  watch: {
    value: function(){
      this.activeName = this.value;
      this.$children.forEach(v => v.activeName = this.value);
    }
  }
  ,
  created() {
    let self = this;
    this.$on('tab.change', function (tabName, otab) {
      // if (self.activeName === tabName) return;
      self.activeName = tabName;
      self.$emit('input', tabName);
      self.$emit('tabchange', tabName, otab);
      self.$children.forEach(v => v.activeName = tabName);
      // console.log('> tab change: ', tabName);
    })
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      self.$children.forEach(v => {
        v.activeName = self.activeName;
        v.hoverable = self.hover;
      });
    });
  }
};
</script>
<style lang="less">
.pcqb-tabs-label-wrap{
  > .pcqb-tabs{
    display: none;
  }
}
.pcqb-tabs{
  display: inline-block;
  font-size: 14px;
  position: relative;
  top: -3px;
  .pcqb-tabs-label{
    box-sizing: border-box;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 1.5em;
    &:hover{
      color: #fa7d1d;
    }
  }
  .pcqb-tabs-label-wrap{
    &:first-child .pcqb-tabs-label{
      padding-left: 0;
    }
    &.pcqb-subtabs.active {
      &:after{
        content: ' ';
        display: block;
        height: 40px;
      }
      > .pcqb-tabs{
        display: block;
        position: absolute;
        white-space: nowrap;
        top: 50%;
        left: 5em;
      }
    }
  }
}
</style>